import * as colors from 'constants/colors'
import styled from "styled-components"

export const Logo = styled.img`
  margin: 0 auto 16px;
  display: block;
`

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 10px;
  color: ${colors.primary01};
`

export const Description = styled.div`
  margin-bottom: 15px;
  text-align: justify;
`

export const Table = styled.table`
  width: 100%;
  border: 1px solid #bfbfbf;
  border-collapse: collapse;
  border-radius: 10px;
  td, th{
    border: 1px solid #bfbfbf;
    border-collapse: collapse;
    vertical-align: middle;
  }
`

export const Thead = styled.thead`
  background-color: ${colors.neutral02};
`

export const Th = styled.th`
  padding: 10px;
  text-align: center;
  gap: 5px;
  font-weight: 600;
  font-size: 15px;

  .emoji{
    font-size: 1.8rem;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  button{
    width: 200px;
  }

  @media(min-width: 768px){
    flex-direction: row;
  }
`

export const ListIntructions = styled.ul`
  margin-top: 10px;
  li{
    margin: 0 0 0 15px;
    list-style: square;
  }
  
`

export const ContainerInstructions = styled.div`
  margin: 10px auto;
  width: 100%;
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media(min-width: 480px){
    width: 80%;
  }

  @media(min-width: 650px){
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @media(min-width: 768px){
    width: 65%;
  }

  img{
    width: 100%;
  }
`